import React from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { TitleWMutedRow } from "../atoms";

const LoadingComponent = ({language}) => (
    <>
    <TitleWMutedRow muted={language.mutedTitle}>{language.title}</TitleWMutedRow>
    <Row>
        <Col>
            <h4 className="d-flex align-items-center">
                <span className="me-2">Please wait </span>
                <Spinner animation="grow" size="sm" />
            </h4>
        </Col>
    </Row>
  </>
);

export default LoadingComponent;
